import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentComponent), {
    onSelectFeedbackType: _ctx.setSelectFeedbackType,
    onNext: _ctx.next
  }, null, 40, ["onSelectFeedbackType", "onNext"]))
}